import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { FunctionComponent, useEffect } from 'react';

import useLoggedUser from '../../../hooks/use-logged-user';
import usePageViewEvent from '../../../hooks/use-page-view-event';
import useOGMeta from '../../../utils/seo/ogmeta';
import useSchema from '../../../utils/seo/schema-org/schema';
import useHreflang from '../../../utils/seo/hreflang';
import { useAppContext } from '../../providers/app-context';

const EcoRepairScoreSchema: FunctionComponent<{
  breadcrumbs: Array<{
    href: LinkProps;
    text: string;
  }>;
}> = ({ breadcrumbs }) => {
  const { t } = useTranslation();
  const user = useLoggedUser();
  const { businessValues } = useAppContext();

  const name = t('eco-repair:head.title');

  const description = t('eco-repair:head.description', {
    totalStockAvailable: businessValues.totalStockAvailable.defaultValue,
  });

  usePageViewEvent(name);

  const { locale = 'en', asPath, query } = useRouter();
  const localePath = locale !== 'en' ? `/${locale}` : '';

  const og = useOGMeta({
    title: name,
    description,
    url: process.env.NEXT_PUBLIC_HOST + localePath + asPath,
  });

  const alternateLinks = useHreflang({
    locale,
    route: 'contacts',
    params: query,
  });

  return (
    <Head>
      <title>{name}</title>
      <meta name="description" content={description} />
      {alternateLinks}
      {og}

      <script {...useSchema({ name, description, breadcrumbs })} />
    </Head>
  );
};

export default EcoRepairScoreSchema;
